import { gql } from "@edreamsodigeo/frontend-api-client";

export const GET_PRIME_SITE_PROPERTIES = gql`
  query PrimeSitePropertiesQuery @ignore_update {
    primeSiteProperties {
      activePrimeMarket {
        flights
        cars
        hotels
        dynpack
      }
      isPossibleReturningPrimeVisitor
    }
  }
`;
